import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Container, Row, Spacer } from "@amzn/stencil-react-components/layout";
import { TabBar, TabPanel, TabSwitcher, useTabs } from "@amzn/stencil-react-components/tabs";
import { Text } from "@amzn/stencil-react-components/text";
import ListModalButton from "common/components/ListModal/ListModalButton";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";
import React, { FC, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { List } from "./List";
import { useLists } from "./useLists";
const ListsPage: FC = () => {
  const history = useHistory();
  const { lists, loading, getLists } = useLists();
  const tabs = [
    getString("lists.tabs.myLists"),
    getString("lists.tabs.sharedLists"),
    getString("lists.tabs.teamLists"),
    getString("lists.tabs.highlights"),
  ];

  const toggleLists = UserPermissions.current.hasPermission(PERMISSIONS.TOGGLE_LISTS);
  const { tabBarProps, tabSwitcherProps } = useTabs({ tabs });

  useEffect(() => {
    getLists();
  }, [getLists]);

  if (!toggleLists) {
    history.push("/");
    return null;
  }

  return (
    <Col>
      <PageMainContainer>
        <Container paddingTop={32} paddingBottom={32}>
          <Col gridGap={32}>
            <Row justifyContent="space-between">
              <Text fontSize="T400" fontWeight="bold" color="neutral90">
                {getString("lists.title")}
              </Text>
              <ListModalButton />
            </Row>
            <Text fontSize="T200" color="neutral90">
              {getString("lists.description")}
            </Text>

            <TabBar {...tabBarProps} />
            <TabSwitcher {...tabSwitcherProps}>
              <TabPanel value={getString("lists.tabs.myLists")}>
                <Col gridGap="S300">
                  {lists.map((list, index) => (
                    <List key={`List-${index}`} {...list} />
                  ))}
                </Col>
              </TabPanel>
              <TabPanel value={getString("lists.tabs.teamLists")}></TabPanel>
              <TabPanel value={getString("lists.tabs.highlights")}></TabPanel>
            </TabSwitcher>
          </Col>
        </Container>
      </PageMainContainer>
    </Col>
  );
};

export default ListsPage;
